<div class="component-content col-lg-6" style="height:90%;">
    <div class="panel panel-success" style="height:90%;">
        <div class="panel-heading">
            <h5 style="display: inline-block">
                <span class="badge">{{ selectedUsers.Data.length }}</span>
                <span>Selected Users</span>
            </h5>
            <div class="btn-toolbar pull-right">
                <div class="btn-group btn-group-md">
                    <button type="button" class="btn btn-primary" title="Restrict Print" (click)="promptNoPrintConfirm()">
                        <span data-toggle="tooltip" class="fa fa-ban fa-lg"></span>
                    </button>
                    <button type="button" class="btn btn-primary" title="Allow Print" (click)="promptPrintConfirm()">
                        <span data-toggle="tooltip" class="fa fa-print fa-lg"></span>
                    </button>
                    <button type="button" class="btn btn-primary" title="Clear Selected" (click)="clearSelectedUsers()">
                        <span data-toggle="tooltip" class="fa fa-trash-o fa-lg"></span>
                    </button>
                </div>
            </div>
        </div>
        <div class="panel-body panel-list" style="height:90%; overflow-y:hidden; padding-bottom:0px; padding-top:0px;">
            <div class="panel-group" style="height:90%; overflow-y:hidden;">
                <div class="list-group" style="height:100%; overflow-y: scroll;">
                    <div class="list-group-item" style="padding-top:0px; padding-bottom:0px;" *ngFor="let user of selectedUsers.Data">
                        <h5 style="display: inline-block">
                            {{ user.FirstName }}
                            <br />
                            {{ user.LastName }}
                        </h5>
                        <div class="pull-right" style="padding-right:15px;">
                            <h5>
                                {{ user.UserName }}
                                <br />
                                {{ user.Permission.Name }} {{ user.Companies.length > 0 ? '*' : '' }}
                            </h5>
                        </div>
                        <div class="clearfix"></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="component-content col-lg-6" style="height:90%;">
    <div class="panel panel-success" style="height:90%;">
        <div class="panel-heading">
            <h5 style="display: inline-block">
                <span class="badge">{{ filteredUsers.length }} / {{ total }}</span>
                <span>Available Users</span>
            </h5>
            <div class="pull-right">
                <div class="btn-group btn-group-md">
                    <a class="btn" title="Filter Users" [class.btn-warning]="filterApplied" [class.btn-primary]="!filterApplied" (click)="showFilters()">
                        <span data-toggle="tooltip" class="fa fa-filter fa-lg"></span>
                    </a>
                </div>
            </div>
        </div>
        <div class="panel-body panel-list" style="height:90%; overflow-y:hidden; padding-bottom:0px; padding-top:0px;">
            <div class="panel-group" style="height:90%; overflow-y:hidden;">
                <div *ngIf="processing" class="list-group" style="overflow-y:scroll; max-height: 600px;">
                    <i class="fa fa-spinner fa-spin"></i> Loading Users...
                </div>
                <div class="list-group" style="height:100%; overflow-y: scroll;" *ngIf="!processing">
                    <div class="list-group-item" [class.list-group-item-success]="user.Selected" style="padding-top:0px; padding-bottom:0px;" *ngFor="let user of filteredUsers; let i = index" (click)="selectUser(user, i+1, $event)">
                        <h5 style="display: inline-block">
                            {{ user.FirstName }}&nbsp;{{ user.LastName}}
                            <br />
                            {{ user.AllowPrinting ? 'Able to Print' : 'Not Able to Print' }}
                        </h5>
                        <div class="pull-right" style="padding-right:15px;">
                            <h5>
                                {{ user.UserName }}
                                <br />
                                {{ user.Permission.Name }} {{ user.Companies.length > 0 ? '*' : '' }}
                            </h5>
                        </div>

                        <div class="clearfix"></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>


<div bsModal #confirmPrint="bs-modal" class="modal fade" [config]="{ keyboard: false, backdrop: 'static' }" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true">
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title" id="myModalLabel">
                    Allow Print Confirmation
                </h4>
            </div>
            <div class="modal-body">
                <div class="row">
                    <div class="col-lg-12">
                        Are you sure you want to allow all these users to print?
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-warning" (click)="allowPrint()">Allow Print</button>
                <button type="button" class="btn btn-primary" (click)="cancelPrint()">Cancel</button>
            </div>
        </div>
    </div>
</div>

<div bsModal #confirmNoPrint="bs-modal" class="modal fade" [config]="{ keyboard: false, backdrop: 'static' }" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true">
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title" id="myModalLabel">
                    Restrict Print Confirmation
                </h4>
            </div>
            <div class="modal-body">
                <div class="row">
                    <div class="col-lg-12">
                        Are you sure you want to restrict these user from printing?
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-warning" (click)="restrictPrint()">Restrict Print</button>
                <button type="button" class="btn btn-primary" (click)="cancelNoPrint()">Cancel</button>
            </div>
        </div>
    </div>
</div>

<div bsModal #userFilter="bs-modal" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true" [config]="{ keyboard: false, backdrop: 'static' }">
    <div class="modal-dialog" style="width:1000px;">
        <div class="modal-content">
            <form (ngSubmit)="applyFilter()">
                <div class="modal-header">
                    <button type="button" class="close" data-dismiss="modal" aria-hidden="true" (click)="applyFilter()">&times;</button>
                    <h4 class="modal-title" id="myModalLabel">Filter Users</h4>
                </div>
                <div class="modal-body">
                    <div class="row">
                        <div class="col-md-12">
                            <div class="input-group">
                                <div class="input-group-addon">
                                    <label>User Name</label>
                                </div>
                                <input name="UserFilterName" type="text" class="form-control" placeholder="User Name" [(ngModel)]="name" />
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-12">
                            <hr />
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-12">
                            <div class="input-group">
                                <div class="input-group-addon">
                                    <label>Permission</label>
                                </div>
                                <select name="selectedPermissions" class="form-control" size="4" multiple="multiple" [(ngModel)]="selectedPermissions">
                                    <option *ngFor="let permission of permissions" [value]="permission.Id">{{ permission.Name }}</option>
                                </select>
                            </div>
                        </div>
                    </div>
                    <div class="row" *ngIf="employeePermissionIncluded()">
                        <div class="col-md-12">
                            <hr />
                        </div>
                    </div>
                    <div class="row" *ngIf="employeePermissionIncluded()">
                        <div class="col-md-12">
                            <div class="input-group">
                                <div class="input-group-addon">
                                    <label>Status</label>
                                </div>
                                <div class="btn-group btn-group-justified">
                                    <div class="btn-group">
                                        <button type="button" class="btn" [class.btn-success]="allEmployees" [class.btn-warning]="!allEmployees" (click)="allEmployees = !allEmployees">
                                            {{ allEmployees ? 'All' : 'Only Specially Assigned' }} Employees
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-12">
                            <hr />
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-6">
                            <div class="input-group">
                                <div class="input-group-addon">
                                    <label>Company</label>
                                </div>
                                <select name="selectedCompaniesUserFilter" class="form-control" size="5" multiple="multiple" [(ngModel)]="selectedCompanies">
                                    <option *ngFor="let company of companies" [value]="company.Id">{{ company.Name }}</option>
                                </select>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="input-group">
                                <div class="input-group-addon">
                                    <label>Minesite</label>
                                </div>
                                <select name="selectedMinesitesUserFilter" class="form-control" size="5" multiple="multiple" [(ngModel)]="selectedMinesites">
                                    <option *ngFor="let minesite of minesites" [value]="minesite.Id">{{ minesite.Name }}</option>
                                </select>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-12">
                            <hr />
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-2">
                            <div class="checkbox">
                                <label><input id="AbleToPrint" name="AbleToPrint" type="checkbox" [(ngModel)]="ableToPrint">Able to Print</label>
                            </div>
                        </div>
                        <div class="col-md-2">
                            <div class="checkbox">
                                <label><input id="NotAbleToPrint" name="NotAbleToPrint" type="checkbox" [(ngModel)]="notAbleToPrint">Not Able to Print</label>
                            </div>
                        </div>
                        <div class="col-md-8">
                            &nbsp;
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-success" *ngIf="filterApplied" (click)="clearFilter()">Clear Filter</button>
                    <button type="submit" class="btn btn-default">Apply Filter</button>
                </div>
            </form>
        </div>
    </div>
</div>